import { HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  public error?: HttpErrorResponse
  public mySubject = new Subject<HttpErrorResponse>()

  public constructor() {}

  public setError(err: HttpErrorResponse): void {
    if (err.url) {
      const urlParts = new URL(err.url)
      if (urlParts.searchParams.get('query')) {
        err.error.error.query = JSON.parse(
          urlParts.searchParams.get('query') as string
        )
      }
      this.error = { ...err, url: decodeURI(err.url) }
    } else {
      this.error = err
    }

    this.mySubject.next(err)
  }
}
